import * as React from 'react';
import styled from 'styled-components';

import { useValuationContext } from '../../../../utils/hooks/useValuationContext';
import { FormError } from '../../../ui/form/FormError';
import { Input } from '../../../ui/form/Input';
import { ButtonGroup } from '../../../ui/button/ButtonGroup';
import { Button } from '../../../ui/button/Button';
import { ButtonLink } from '../../../ui/link/ButtonLink';

export const ValuationForm: React.FC = () => {
  const { loading, error, fields, onChange, onSubmit } = useValuationContext();

  return (
    <Form onSubmit={onSubmit} noValidate>
      {error?.graphQLErrors?.map((error) => (
        <FormError message={error.message} />
      ))}
      <FormFieldsWrapper>
        {fields
          .filter((item) => item?.type !== 'checkbox')
          .map((item, index) => {
            return (
              <FormRow key={`field_${index}`} className={item?.name ?? ``}>
                <Input
                  type={item?.type}
                  name={item?.name}
                  label={item?.label}
                  labelAfter={item?.labelAfter}
                  value={item?.value}
                  onChange={onChange}
                  error={item?.error}
                />
                {item?.error && (
                  <Error> {item.label} er påkrevd / ugyldig </Error>
                )}
                {!item?.error && (
                  <PlaceHolderText>{item?.placeholder}</PlaceHolderText>
                )}
              </FormRow>
            );
          })}
      </FormFieldsWrapper>
      <StyledContainer>
        <ButtonGroup className="item">
          <Button
            type="primary"
            className="contact"
            colorTheme="coral"
            disabled={loading}
            loading={loading}
          >
            Kontakt meg
          </Button>
          <ButtonLink
            as="link"
            to="/personvern"
            className="privacy-link-mobile"
          >
            Personvernpolicy
          </ButtonLink>
        </ButtonGroup>
      </StyledContainer>
    </Form>
  );
};

export const Form = styled.form`
  width: 100%;
  max-width: 550px;
  margin: 0 auto;
  .contact-btn {
    font-weight: 700;
    font-family: 'Geograph-Regular', sans-serif;
    :hover {
      background: ${(props) => props.theme.colors.primary};
      color: ${(props) => props.theme.colors.black};
    }
  }
  .contact-btn {
    margin: 28px 0 8px;
  }
  .btn-group {
  }
  @media all and (min-width: 800px) {
    .btn-group {
      margin: 36px 0 0;
    }
    .contact-btn {
      margin: unset;
    }
  }
`;
export const FormFieldsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 10px;

  @media all and (min-width: 600px) {
    grid-template-columns: repeat(5, 1fr);
    grid-row-gap: 24px;
  }
`;

export const FormRow = styled.div`
  margin-right: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &.address {
    height: 100%;
    @media all and (min-width: 600px) {
      grid-column: span 4;
    }
  }
  .placeholder {
  }

  &.zip {
    height: 100%;
    margin-top: 14px;
    @media all and (min-width: 600px) {
      margin-top: unset;
    }
  }

  &.phone {
    height: 100%;
    margin-top: 24px;
    @media all and (min-width: 600px) {
      margin-top: unset;
      grid-column: span 2;
    }
  }

  &.email {
    height: 100%;
    margin-top: 14px;
    @media all and (min-width: 600px) {
      margin-top: unset;
      grid-column: span 3;
    }
  }
`;

const PlaceHolderText = styled.div`
  font-size: 13px;
  color: #ede0cc;
  letter-spacing: 0.1em;
`;

const Error = styled.div`
  font-size: 13px;
  color: rgb(255, 88, 93);
  margin-left: 10px;
  letter-spacing: 0.1em;
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  gap: 0;

  .item {
    margin: 0 0 24px 0;

    @media all and (min-width: 800px) {
      margin-bottom: 36px;
    }
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .consent {
    margin-bottom: 24px;

    .consent-list {
      padding: 1em 0 0;
      margin: 0;
    }

    .consent-title {
      margin: 0;
    }

    .consent-item {
      &:last-child {
        margin-bottom: 0;
      }
    }

    @media all and (min-width: 600px) {
      margin-bottom: 36px;
    }

    &.last {
      margin: 0;
    }
  }
`;
